import filter from 'lodash/filter';
import find from 'lodash/find';
export default class activitieservice {
    constructor(activities) {
        this._activities = activities;
    }
    getActivityById(activityId) {
        return find(this._activities, (activity) => activity.id == activityId) || null;
    }
    getActivityByGroup(groupId) {
        return filter(this._activities, (activity) => activity.skupina == groupId);
    }
    get nonGrouped() {
        return filter(this._activities, (activity) => activity.skupina === null);
    }
    get activities() {
        return this._activities;
    }
}
